// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_appear.js'; import './autoload/_bootstrap.js'; import './autoload/_custombox.js'; import './autoload/_fancybox.js'; import './autoload/_hs-focus-state.js'; import './autoload/_hs-megamenu.js'; import './autoload/_malihu-custom-scrollbar-plugin.js'; import './autoload/hs-core.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import archive from './routes/archive';
import myAccount from './routes/account';
import editProfile from './routes/edit-profile';
import onlineCourseEnrolment from './routes/online-course-enrolment';
import onlineCourseEditEnrolment from './routes/online-course-edit-enrolment';
import onlineCourseExtension from './routes/online-course-extension';
import onlineDementiaCourses from './routes/online-dementia-courses';
import retakeCourse from './routes/retake-course';
import singleEnrolment from './routes/single-enrolment';
import singleDownloads from './routes/single-downloads';
import singleOnlineCourse from './routes/single-online-course';
import searchResults from './routes/search-results';
import feedback from './routes/feedback';
import feedbackKt from './routes/feedback-kt';
import dtaOnlineCoursesInsights from './routes/dta-online-courses-insights';
import dtaCertificate from './routes/dta-certificate';
import ktCertificate from './routes/kt-certificate';
import dtaReports from './routes/dta-reports';
import dtaEnrolmentsInsights from './routes/dta-enrolments-insights';
import surveyOneResults from './routes/survey-one-results';
import surveyTwoResults from './routes/survey-two-results';
import ttpReport from './routes/ttp-report';
import workshopReport from './routes/workshop-report';
import onlineCourse from './routes/online-course';
import myEnrolments from './routes/my-enrolments';
import generateEventCertificate from './routes/generate-event-certificate';
import generateCourseCertificate from './routes/generate-course-certificate';
import lpSearch from './routes/lp-search';
import lpResults from './routes/lp-results';
import lpShortlist from './routes/lp-shortlist';
import trainingPlanBuilder  from './routes/training-plan-builder';
import trainingPlanBuilderShortlist from './routes/training-plan-builder-shortlist';
import trainingPlanBuilderPlanListing from './routes/training-plan-builder-plan-listing';
import trainingPlanBuilderSearches from './routes/training-plan-builder-searches';
import trainingPlanBuilderPlan from './routes/training-plan-builder-plan';
import singleLpListing from './routes/single-lp-listing';
import myTrainingPlan from './routes/my-training-plan';
import singleLearningPathway from './routes/single-learning-pathway';
import trainingPlanBuilderSearch from './routes/training-plan-builder-search';
import downloadResource from './routes/download-resources-files';
import singleTtp from './routes/single-ttp';
import singleWorkshop from './routes/single-workshop';
import courseUpdatePage from './routes/course-update-page';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // All archive pages
  archive,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // My Account page
  myAccount,
  // Edit Profile
  editProfile,
  // Scorm Cloud iFrame Page
  onlineCourse,
  // Dementia Courses Page
  onlineDementiaCourses,
  // Course Enrolment Page
  onlineCourseEnrolment,
  // Course Enrolment Edit Page
  onlineCourseEditEnrolment,
  // Course Extension Request Page
  onlineCourseExtension,
  // Retake Course Request Page
  retakeCourse,
  // Single Enrolment Pages
  singleEnrolment,
  // Single Downloads Pages
  singleDownloads,
  // Single Online Course Pages
  singleOnlineCourse,
  // Search Archive Page
  searchResults,
  // Feedback Page
  feedback,
  // KT Feedback Page
  feedbackKt,

  dtaOnlineCoursesInsights,
  courseUpdatePage,
  

  dtaEnrolmentsInsights,
  // Survey One Results
  surveyOneResults,
  // Survey One Results
  surveyTwoResults,
  // TTP Report
  ttpReport,
  //Workshop Report
  workshopReport,
  // My enrolments
  myEnrolments,
  //Generate Event Certificates
  generateEventCertificate,
  //Generate Course Certificates
  generateCourseCertificate,
  dtaCertificate,
  ktCertificate,
  dtaReports,
  singleTtp,
  singleWorkshop,
  
  //generate search results
  lpSearch,
  //generate search results
  lpResults,

  lpShortlist,

  trainingPlanBuilder,

  trainingPlanBuilderShortlist,
  
  trainingPlanBuilderPlanListing,

  trainingPlanBuilderSearches,

  trainingPlanBuilderPlan,

  singleLpListing,

  myTrainingPlan,

  singleLearningPathway,

  trainingPlanBuilderSearch,
  //download resources
  downloadResource

});

// Load Events
jQuery(() => routes.loadEvents());




// WEBPACK FOOTER //
// ./scripts/main.js